/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
var trackingUtils = require('../../modules/utils/tracking.utils');
var strategies = {
    results: {
        getElement: function(fareItineraryKey) {
            return $('#results').find('.fare_upgrade_container').filter('[data-fare-itinerary="' + fareItineraryKey + '"]');
        },
    },
};

module.exports = Odigeo.View.extend({
    tmpl: {
        fareUpgrade: '.fare_upgrade_template',
    },
    selectors: {
        fareUpgradeItem: '.fare_upgrade_item',
        fareUpgradeItemChecked: '.fare_upgrade_item:checked',
    },
    events: {
        'tap .fare_toggle': 'onTapMoreInfo',
        'tap .book_btn_new': 'onTapContinue',
        'tap .book_btn_new_desktop': 'onTapContinueDesktop',
        'tap .fare_open': 'onTapOpen',
    },

    init: function() {
        this.tmpl = Odigeo.Utils.getTemplates(this.$el, this.tmpl);
        this.opts = Odigeo.parseOptions(this.widget.options);
        this.opts.perks.displayFormatted = this.opts.perks.display.split(',');
        this.listenTo(this.model, 'fetch:success', this.changeView);
    },

    changeView: function() {
        var strategy = this.getStrategy();
        this.setElement(strategy.getElement(this.model.getFareItineraryKey()));
        this.refresh();
    },

    render: function() {
        var itineraryData = Odigeo._.get(this.model.get('itineraryData'), 'data', {});

        this.$el.html(this.tmpl.fareUpgrade({
            numberOfSegments: Odigeo._.size(itineraryData.segmentKeys),
            getTranslations: Odigeo._.bind(this.model.getTranslation, this),
            getServiceTranslation: Odigeo._.bind(this.model.getServiceTranslation, this),
            pluralizeAll: Odigeo._.bind(Odigeo.Utils.pluralizeAll, Odigeo.Utils),
            getIconClass: this.getIconClass,
            getDisplayClass: Odigeo._.bind(this.getDisplayClass, this),
            fareUpgrades: this.model.getFormattedFareUpgrades(),
            getBagInfo: Odigeo._.bind(this.getBagInfo, this),
            formatPrice: this.formatPrice,
        }));

        this.toggle(true);
    },

    onTapOpen: function(e) {
        e.preventDefault();
        var $fareOpen = $(e.currentTarget).parent().find('.fare_upgrade_details_popup');
        $fareOpen.toggleClass('open opened');
    },

    empty: function() {
        this.$el.empty();
        this.toggle(false);
    },

    toggle: function(hasToOpen) {
        this.$el.toggleClass('open', hasToOpen);
    },

    onTapContinueDesktop: function(e) {
        var data = Odigeo._.get(this.widget.model.get('flightSelection'), 'data');
        var $fareUpgradeItemChecked = $(e.currentTarget);
        data.data.fareFamily = $fareUpgradeItemChecked.data('name');
        data.data.fareFamilyAmount = $fareUpgradeItemChecked.data('price');
        Odigeo.Session.set('fareFamiliesSelectedDisableNags',
            Odigeo.AB.isHidePaxNagsWithFare && $fareUpgradeItemChecked.data('id') !== 0);
        Odigeo.trigger(this.widget.id + ':onContinue', data);
    },

    onTapContinue: function() {
        var data = Odigeo._.get(this.widget.model.get('flightSelection'), 'data');
        var $fareUpgradeItemChecked = this.$el.find(this.selectors.fareUpgradeItemChecked);
        var trackingParam;
        data.data.fareFamily = $fareUpgradeItemChecked.data('name');
        data.data.fareFamilyAmount = $fareUpgradeItemChecked.data('price');
        trackingParam = this.model.getUpgradeFareTrackingParam(data.data.fareFamily, data.data.fareFamilyAmount);
        trackingUtils.trackEvent('results_list', 'select_result_farefam:all-fare:' + trackingParam);
        Odigeo.trigger(this.widget.id + ':onContinue', data);
    },

    onTapMoreInfo: function(e) {
        var trackingParam;
        var $fareUpgradeItem;
        e.preventDefault();
        var $fareOpen = $(e.currentTarget).closest('.fare_upgrade_list');
        $fareOpen.toggleClass('open').siblings('.fare_upgrade_list').removeClass('open');
        $fareUpgradeItem = $fareOpen.find(this.selectors.fareUpgradeItem);
        trackingParam = this.model.getUpgradeFareTrackingParam($fareUpgradeItem.data('name'), $fareUpgradeItem.data('price'));
        trackingUtils.trackEvent('results_list', 'open_info_farefam:all-fare:' + trackingParam);
    },

    formatPrice: function(price) {
        var formattedPrice = Odigeo.Utils.splitFormatedCurrency(price);
        return [formattedPrice.sufix, formattedPrice.integer, formattedPrice.decimal];
    },

    getIconClass: function(availabity) {
        switch (availabity) {
            case 'INCLUDED':
                return 'odf-icon-tick odf-text-positive';
            case 'AVAILABLE_AT_A_CHARGE':
                return 'odf-icon-tick odf-text-mono-color-05';
            case 'NOT_OFFERED':
                return 'odf-icon-cross-light odf-text-negative';
        }
    },

    getBagInfo: function(perk) {
        var perkUnits = (Odigeo._.isNull(perk.units) ? 1 : perk.units );
        var bagInfo = perkUnits + ' ';
        bagInfo += Odigeo.Utils.pluralizeAll(this.model.getTranslation('bags'), perkUnits) + ' ';
        if (perk.weight > 0) {
            bagInfo += perk.weight + ' ' + this.model.getTranslation('kg');
        }
        return bagInfo;
    },

    getDisplayClass: function(perk, areIncluded) {
        var displayClass = 'od-perk-hidden';
        if ((perk === 'INCLUDED') || (!areIncluded && perk === 'AVAILABLE_AT_A_CHARGE')) {
            displayClass = 'od-perk-visible';
        }
        return displayClass;
    },

    getStrategy: function() {
        return Odigeo._.get(strategies, Odigeo.History.getPageNameFromFragment(), Odigeo._.noop);
    },
});
